import { useModalContext } from "../../contexts/ModalContext";
import gear from "../../assets/images/svg/gear";

const OpenProfileModalButton = () => {

  const { openProfileModal } = useModalContext()

  const buttonCss = `headerBtn`

  const handleClick = (e) => {
    e.preventDefault()
    openProfileModal()
  };

  return (
    <button className={buttonCss} onClick={handleClick}>
      {gear}
    </button>
  )
}

export default OpenProfileModalButton;